import React from "react";
import "../App.css";

function Footer() {
  return (
    <div className="footer">
      <div className="footer-inner">
        <span style={{color: 'rgba(255,255,255,0.4)', fontSize: '0.72rem', marginRight: '4px'}}>&#128279;</span>
        <span>© 2024 Department of Science and Technology, Government of Odisha · LandChain Registry</span>
        <div className="footer-links">
          <a href="#">Privacy</a>
          <a href="#">Help</a>
          <a href="#">Contact</a>
        </div>
      </div>
    </div>
  );
}

export default Footer;
